import React, {useEffect} from 'react';
import {useLocation, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {TeamHeader} from "../../header/TeamHeader";
import {Loading} from "../../../../ui/loading/Loading";
import {setRoute} from "../../../../../store/routes";
import {getOrganizationTeam} from "../../../../../store/user_organizations/teams/team";
import {getCnAData} from "../../../../../store/user_organizations/teams/tools/connect_and_align";
import {CollabMessagesPage} from "./CollabMessagesPage";

export const CollabMessages = () => {
    const {organization_id, team_id} = useParams();
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const cna = useSelector((state:any) => state.tool_cna);
    const organization_team = useSelector((state:any) => state.organization_team);

    const urlHandled = () => {
        dispatch(setRoute(pathname));
        const orgTeamId = `${organization_id}_${team_id}`;
        window.history.replaceState(
            window.history.state || null,
            "CollabMessages",
            "/collab/messages?i=" + btoa(orgTeamId)
        );
    };

    useEffect(() => {
        document.title = 'All Messages | Zynity';
        dispatch(getOrganizationTeam({organization_id, team_id}));
        dispatch(getCnAData({organization_id, team_id}));
        urlHandled();
    }, [dispatch, pathname, organization_id, team_id, cna.pastDate]);

    if (organization_team.isLoading === true) {
        return <Loading />;
    }

    return (
        <>
            <TeamHeader suffixRoute='/collab/messages' />
            <CollabMessagesPage />
        </>
    );
};
